import { useNavigate } from "@tanstack/react-router";
import type { ColumnDef } from "@tanstack/react-table";

// Icons
import { MoreHorizontal, ArrowUpDown } from "lucide-react";

// UI
import { Button } from "@/components/ui/button";

// Icons
import { Pencil } from "lucide-react";

// Types
import type { News } from "../types";

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
// TODO: ເອົາ Field ແທ້ມາໃສ່

export const columns: ColumnDef<News>[] = [
	{
		id: "no",
		accessorFn: (_, index) => index + 1,
		header: ({ column }) => {
			return (
				<Button

					onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
				>
					ລຳດັບ
					<ArrowUpDown className="w-4 h-4 ml-2" />
				</Button>
			);
		},
		cell: (info) => info.row.index + 1,
	},
	{
		accessorKey: "title",
		header: "ຫົວຂໍ້ຂ່າວ",
	},
	{
		header: "ປະເພດຂອງຂ່າວສານ",
		cell: ({ row }) => {
			const data = row.original;

			return <p>{data.info_type_id} </p>;
		},
	},

	{
		accessorKey: "updated_at",
		header: ({ column }) => {
			return (
				<Button

					onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
				>
					ອັບເດດລ່າສຸດ
					<ArrowUpDown className="w-4 h-4 ml-2" />
				</Button>
			);
		},
	},
	{
		header: "ອັບເດດໂດຍ",
		cell: ({ row }) => {
			const data = row.original;

			return (
				<p>
					{data.updated_by.first_name} {data.updated_by.last_name}
				</p>
			);
		},
	},

	{
		id: "actions",
		cell: ({ row }) => {
			const data = row.original;

			const navigate = useNavigate();

			return (
				<Button
					variant="outline"
					className="z-10 w-8 h-8 p-0"
					onClick={() => {
						navigate({
							to: "/news/mutate",
							search: {
								id: data.id,
								data: JSON.stringify(data),
							},
						});
						console.log(data.id);
					}}
				>
					<Pencil className="w-4 h-4" />
				</Button>
			);
		},
	},
];
